// src/pages/Dashboard.jsx
import React, { useEffect, useState } from "react";
import API from "../api/api";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function Dashboard() {
  const [stats, setStats] = useState({ users: 0, answered: 0, noAnswer: 0, busy: 0 });

  const fetchStats = async () => {
    try {
      const usersRes = await API.get("/account/list");
      const logsRes = await API.get("/getAIRecording-logs", { params: { page: 1, limit: 1000 } });

      setStats({
        users: usersRes.data.data.length,
        answered: logsRes.data.data.filter((l) => l.status === "ANSWERED").length,
        noAnswer: logsRes.data.data.filter((l) => l.status === "NO ANSWER").length,
        busy: logsRes.data.data.filter((l) => l.status === "BUSY").length,
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const barData = {
    labels: ["Answered", "No Answer", "Busy"],
    datasets: [
      {
        label: "AI Calls",
        data: [stats.answered, stats.noAnswer, stats.busy],
        backgroundColor: ["#198754", "#dc3545", "#ffc107"],
      },
    ],
  };

  return (
    <div className="row mb-3">
      <div className="col-md-4">
        <div className="card p-3 text-center">
          <h5>Total Users</h5>
          <h3>{stats.users}</h3>
        </div>
      </div>
      <div className="col-md-8">
        <div className="card p-3">
          <Bar data={barData} />
        </div>
      </div>
    </div>
  );
}